import { ValidationResult } from "../interfaces/all";

export const validateCPF = (value: string): ValidationResult => {
  // Remove caracteres não numéricos
  const cpf = value.replace(/\D/g, "");

  if (cpf.length === 0) {
    return { isValid: true };
  }

  if (cpf.length !== 11) {
    return {
      isValid: false,
      error: "CPF deve conter 11 dígitos",
    };
  }

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) {
    return {
      isValid: false,
      error: "CPF inválido",
    };
  }

  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rest = 11 - (sum % 11);
  const digit1 = rest > 9 ? 0 : rest;
  if (digit1 !== parseInt(cpf.charAt(9))) {
    return {
      isValid: false,
      error: "CPF inválido",
    };
  }

  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rest = 11 - (sum % 11);
  const digit2 = rest > 9 ? 0 : rest;
  if (digit2 !== parseInt(cpf.charAt(10))) {
    return {
      isValid: false,
      error: "CPF inválido",
    };
  }

  return { isValid: true };
};

export const formatCPF = (value: string): string => {
  const cpf = value.replace(/\D/g, "");
  if (cpf.length <= 3) return cpf;
  if (cpf.length <= 6) return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
  if (cpf.length <= 9)
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
};
